<template>
  <div class="grid rb-diamonds-grid">
    <div
      class="grid-item rb-diamond-item"
      v-for="diamond in diamondsData.diamonds"
      :key="`diamond-item-${diamond.sku}`"
    >
      <div>
        <div class="rb-diamond-image">
          <v-360
            :diamond="diamond"
            mode="video"
            :api="api.visionViewer"
            :favorites="favorites"
          ></v-360>
        </div>
        <div class="rb-diamond-data">
          <diamond-card
            :data="data"
            :diamond="diamond"
            :selected-options="selectedOptions"
            :selectors="selectors"
            :data-price="dataPrice"
            :favorites="favorites"
            :combine-price="combinePrice"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Displays a list of diamonds as cards in a grid
 *
 * @props
 * api: Object
 * selectors: Boolean
 * dataPrice: Object
 *
 * @implements
 * ChildMixin
 * DiamondsMixin
 * CommMixin
 * FavsMixin
 *
 * @emits
 * "rb-open-popup"
 */
import ChildMixin from "@/mixins/ChildMixin";
import CommMixin from "@/mixins/CommMixin";
import DiamondsMixin from "@/mixins/DiamondsMixin";
import DiamondCard from "@/components/DiamondCard";
import V360 from "@/components/V360";
import FavsMixin from "@/mixins/FavsMixin";
export default {
  mixins: [ChildMixin, DiamondsMixin, CommMixin, FavsMixin],
  components: { DiamondCard, V360 },
  props: {
    api: {
      type: Object,
    },
    selectors: {
      type: Boolean,
      default: true,
    },
    dataPrice: {
      type: Object,
    },
    combinePrice: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    notifyGiaCertificate: function () {
      this.broadcast("rb-open-popup", { id: "rb-popup-gia" });
    },
  },
};
</script>
